import { Lock as LockClosed24Regular, LogOut as SignOut24Regular } from "lucide-react";
import { useMsal } from "@azure/msal-react";
import { SkyButton, SkyCard, SkyBody1, SkyTitle2 } from "@skypointcloud/skypoint-ui";

export function BlockedAccountScreen() {
  const { instance } = useMsal();

  const handleSignOut = () => {
    instance.logoutRedirect();
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-surface-subtle">
      <SkyCard className="max-w-[440px] w-full flex flex-col items-center gap-4 text-center px-8 py-10">
        <LockClosed24Regular
          className="text-fg-danger w-[48px] h-[48px]"
          fontSize={48}
        />
        <SkyTitle2 className="mt-2">Your account has been blocked</SkyTitle2>
        <SkyBody1 className="text-fg-2">
          Your administrator has blocked access to this account. If you believe this is an error,
          please contact your administrator.
        </SkyBody1>
        <div className="mt-2 flex flex-col items-center gap-4 w-full">
          <SkyButton
            appearance="primary"
            icon={SignOut24Regular}
            onClick={handleSignOut}
          >
            Sign Out
          </SkyButton>
          <a
            href="mailto:support@skypoint.ai"
            className="no-underline hover:underline text-fg-2"
            style={{ fontSize: "12px" }}
          >
            Need help? support@skypoint.ai
          </a>
        </div>
      </SkyCard>
    </div>
  );
}

export default BlockedAccountScreen;
